var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import styles from './heading.styles';
import { SgdfElement } from '../../internal/sgdf-element';
import { classMap } from 'lit/directives/class-map.js';
let SgdfHeading = class SgdfHeading extends SgdfElement {
    constructor() {
        super(...arguments);
        this.heading = 'h1';
        this.level = 1;
        this.neutral = false;
    }
    render() {
        const headingClasses = classMap({
            label: true,
            heading: this.level === 1,
            subheading: this.level === 2,
            subsubheading: this.level === 3,
            subsubsubheading: this.level === 4,
        });
        return html `<div
            class=${classMap({
            container: true,
            default: !this.neutral,
            neutral: this.neutral,
        })}
        >
            ${this.heading === 'h1'
            ? html `<h1 class=${headingClasses}>
                      <slot></slot>
                  </h1>`
            : html `<h2 class=${headingClasses}><slot></slot></h2>`}
            <slot name="actions"></slot>
        </div> `;
    }
};
SgdfHeading.styles = styles;
__decorate([
    property({ type: String })
], SgdfHeading.prototype, "heading", void 0);
__decorate([
    property({ type: Number })
], SgdfHeading.prototype, "level", void 0);
__decorate([
    property({ type: Boolean })
], SgdfHeading.prototype, "neutral", void 0);
SgdfHeading = __decorate([
    customElement('sgdf-heading')
], SgdfHeading);
export { SgdfHeading };
//# sourceMappingURL=heading.js.map